<template>
    <v-card>
        <v-card-title class="title">Розподілити студенти та білети</v-card-title>
        <v-card-text>
            Ви впевнені, що хочете провести розподіл ВСІХ студентів (всі спеціальості) та білетів на ВИБРАНУ дату?
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    text
                    @click.native="$emit('shouldCloseDeleteConfirm')"
                    :disabled="isLoading"
            >Відміна
            </v-btn>
            <v-btn
                    color="red"
                    dark
                    @click.native="removeItem"
                    :loading="isLoading"
                    :disabled="isLoading"
            >Розподілити
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import HttpService from "../../../HttpService";

    export default {
        data: () => {
            return {
                isLoading: false,
            };
        },
        props: {
            deleteId: Number,
        },
        methods: {
            removeItem() {
                this.loadingDelete = true;

                HttpService.getInstance()
                    .post(`FinalExamAdminManage/DistributeStudents?dateStr=${this.$route.params.date}`)
                    .then(resp => {
                        this.isLoading = false;

                        this.$emit("removed");
                    });
            }
        }
    }
</script>